import {  LoyaltyModel } from "@NA/Widgets/LoyaltyRewards/LoyaltyRewardsModel";
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, get,ServiceResult,patch } from "@NA/Services/ApiService";

// Below added interface is P21 Change ----- P21 Change
export interface BatchgetCustomParameter extends ApiParameter {
    extendedNames: string[];
}
// Below added interface is P21 Change ----- P21 Change
export interface RqfproductvalidationParameter extends ApiParameter {
    companyCode: string;
    productList: string[];
}

// Below added interface is P21 Change ----- P21 Change
export interface RQFProductVisibilityParameter extends ApiParameter{
    companyName:string
    productList: string[];
}

// Below added interface is P21 Change ----- P21 Change
export interface ProductVisibilityRequest {
    companyName: string;
    customerNumber: string,
    productList: string[]
}


const deliveryLocUrl = "/api/v2/getdeliveryloc";
// Below added are from P21 ----- P21 Change
const batchgetCustomUrl = "/api/v3/adiglobalproducts/batchgetCustom";
const RQFP21ProductValidationUrl = "/api/v1/requestQuote/RQFP21ProductValidation";
const rfqProductVisibilityUri="/api/v1/requestQuote/RQFProductVisibility"


export const getDeliveryLoc = (parameter?: ApiParameter) => {
    return get<any>(`${deliveryLocUrl}`, parameter);
};

// Below added function is P21 Change ---- P21 Change
export async function RQFProductVisibility(parameter: ProductVisibilityRequest): Promise<ServiceResult<any>> {
    const { companyName,productList,customerNumber } = parameter;
    try {
        const rfqProductVisibility=  await patch<any>(rfqProductVisibilityUri, {
            companyName: companyName,
            productList: productList,
            customerNumber:customerNumber
          
        } as any)
        return {
            result:rfqProductVisibility,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
                result:{}
            };
        }
        throw error;
    }
}



